namespace Matrix.Data {
    export class QueueFieldColumns {
        static columnsKey = 'Workflow.QueueField';
    }
}
